/* eslint-disable jsx-a11y/anchor-is-valid */
import React, {useState, useCallback, useEffect} from 'react'
import axios from 'axios'
import {debounce} from 'lodash'
import {KTIcon} from '../../../../../_metronic/helpers'
import {StepProps} from '../IAppModels'
import {useAuth} from '../../../../../app/modules/auth'
import {parseJsonObject} from '../../../../../utils/parseJsonObject'

const Step1 = ({
  data,
  updateData,
  hasError,
  onValidationChange,
  claimDetails,
}: StepProps & {onValidationChange: (isValid: boolean) => void}) => {
  const user = useAuth()
  const {auth} = useAuth()
  const [icdData, setIcdData] = useState([])
  const [icdData2, setIcdData2] = useState([])
  const [icdData3, setIcdData3] = useState([])
  const [icdData4, setIcdData4] = useState([])
  const [dropdownVisible, setDropdownVisible] = useState(false)
  const [dropdownVisible2, setDropdownVisible2] = useState(false)
  const [dropdownVisible3, setDropdownVisible3] = useState(false)
  const [dropdownVisible4, setDropdownVisible4] = useState(false)

  const jsonString = claimDetails?.claimDetails?.detailBenefit
  const parsedJson = parseJsonObject(jsonString)

  const parsedMemberDetail = claimDetails.claimDetails?.memberDetail
    ? JSON.parse(claimDetails.claimDetails?.memberDetail)
    : {}
  const [productCode, setProductCode] = useState<string>('')
  const [isProductCodeLoaded, setIsProductCodeLoaded] = useState<boolean>(false)

  // Add hover state tracking for inputs and textareas
  const [hoveredInput, setHoveredInput] = useState('')

  // Define input styles
  const getInputStyle = (inputName: string) => {
    return {
      backgroundColor: 'white',
      border: '1px solid #e4e6ef',
      transition: 'all 0.3s ease',
      ...(hoveredInput === inputName && {
        borderColor: '#059BB6',
        boxShadow: '0 0 5px rgba(5, 155, 182, 0.5)',
      }),
    }
  }

  console.log('Token Step1: ', user.currentUser?.token)

  const fetchIcdData = useCallback(
    debounce(async (identifier, searchTerm) => {
      if (searchTerm.length <= 2 || !productCode) return

      const apiUrl = `${process.env.REACT_APP_API_USER_URL}/api/Exclusion/GetPaginatedMstIcd10s?searchTerm=${searchTerm}&pageNumber=1&pageSize=10&productCode=${productCode}&planCode=${parsedJson.PlanCode}&benefitCode=${parsedJson.BenefitCode}`
      try {
        const response = await axios.get(apiUrl, {
          headers: {
            Authorization: `Bearer ${auth?.token}` || `Bearer ${user.currentUser?.token}`,
          },
        })
        const data = response.data.data || []
        console.log(`Fetched data for ${identifier}:`, data)
        setIcdData(data)
        setDropdownVisible(data.length > 0)
      } catch (err) {
        console.error('Error fetching ICD-10 data:', err)
      }
    }, 300),
    [productCode, auth?.token, user.currentUser?.token, parsedJson.PlanCode, parsedJson.BenefitCode]
  )

  const fetchIcdData2 = useCallback(
    debounce(async (identifier, searchTerm) => {
      if (searchTerm.length <= 2 || !productCode) return

      const apiUrl = `${process.env.REACT_APP_API_USER_URL}/api/Exclusion/GetPaginatedMstIcd10s?searchTerm=${searchTerm}&pageNumber=1&pageSize=10&productCode=${productCode}&planCode=${parsedJson.PlanCode}&benefitCode=${parsedJson.BenefitCode}`
      try {
        const response = await axios.get(apiUrl, {
          headers: {
            Authorization: `Bearer ${auth?.token}` || `Bearer ${user.currentUser?.token}`,
          },
        })
        const data = response.data.data || []
        console.log(`Fetched data for ${identifier}:`, data)
        setIcdData2(data)
        setDropdownVisible2(data.length > 0)
      } catch (err) {
        console.error('Error fetching ICD-10 data:', err)
      }
    }, 300),
    [productCode, auth?.token, user.currentUser?.token, parsedJson.PlanCode, parsedJson.BenefitCode]
  )

  const fetchIcdData3 = useCallback(
    debounce(async (identifier, searchTerm) => {
      if (searchTerm.length <= 2 || !productCode) return

      const apiUrl = `${process.env.REACT_APP_API_USER_URL}/api/Exclusion/GetPaginatedMstIcd10s?searchTerm=${searchTerm}&pageNumber=1&pageSize=10&productCode=${productCode}&planCode=${parsedJson.PlanCode}&benefitCode=${parsedJson.BenefitCode}`
      try {
        const response = await axios.get(apiUrl, {
          headers: {
            Authorization: `Bearer ${auth?.token}` || `Bearer ${user.currentUser?.token}`,
          },
        })
        const data = response.data.data || []
        setIcdData3(data)
        setDropdownVisible3(data.length > 0)
      } catch (err) {
        console.error('Error fetching ICD-10 data:', err)
      }
    }, 300),
    [productCode, auth?.token, user.currentUser?.token, parsedJson.PlanCode, parsedJson.BenefitCode]
  )

  const fetchIcdData4 = useCallback(
    debounce(async (identifier, searchTerm) => {
      if (searchTerm.length <= 2 || !productCode) return

      const apiUrl = `${process.env.REACT_APP_API_USER_URL}/api/Exclusion/GetPaginatedMstIcd10s?searchTerm=${searchTerm}&pageNumber=1&pageSize=10&productCode=${productCode}&planCode=${parsedJson.PlanCode}&benefitCode=${parsedJson.BenefitCode}`
      try {
        const response = await axios.get(apiUrl, {
          headers: {
            Authorization: `Bearer ${auth?.token}` || `Bearer ${user.currentUser?.token}`,
          },
        })
        const data = response.data.data || []
        setIcdData4(data)
        setDropdownVisible4(data.length > 0)
      } catch (err) {
        console.error('Error fetching ICD-10 data:', err)
      }
    }, 300),
    [productCode, auth?.token, user.currentUser?.token, parsedJson.PlanCode, parsedJson.BenefitCode]
  )

  const handleInputChange = (identifier, e) => {
    const {value} = e.target
    updateData({
      appBasic: {
        ...data.appBasic,
        [identifier]: value,
      },
    })
    fetchIcdData(identifier, value)
  }

  const handleInputChange2 = (identifier, e) => {
    const {value} = e.target
    updateData({
      appBasic: {
        ...data.appBasic,
        [identifier]: value,
      },
    })
    fetchIcdData2(identifier, value)
  }

  const handleInputChange3 = (identifier, e) => {
    const {value} = e.target
    updateData({
      appBasic: {
        ...data.appBasic,
        [identifier]: value,
      },
    })
    fetchIcdData3(identifier, value)
  }

  const handleInputChange4 = (identifier, e) => {
    const {value} = e.target
    updateData({
      appBasic: {
        ...data.appBasic,
        [identifier]: value,
      },
    })
    fetchIcdData4(identifier, value)
  }

  const handleSelectIcd = (icd: any) => {
    const selectedValue = `${icd.code} - ${icd.name}`
    updateData({
      appBasic: {
        ...data.appBasic,
        icd10: selectedValue,
      },
    })
    setIcdData([])
    setDropdownVisible(false)
  }

  const handleSelectIcd2 = (icd: any) => {
    const selectedValue = `${icd.code} - ${icd.name}`
    updateData({
      appBasic: {
        ...data.appBasic,
        icd102: selectedValue,
      },
    })
    setIcdData2([])
    setDropdownVisible2(false)
  }

  const handleSelectIcd3 = (icd: any) => {
    const selectedValue = `${icd.code} - ${icd.name}`
    updateData({
      appBasic: {
        ...data.appBasic,
        icd103: selectedValue,
      },
    })
    setIcdData3([])
    setDropdownVisible3(false)
  }

  const handleSelectIcd4 = (icd: any) => {
    const selectedValue = `${icd.code} - ${icd.name}`
    updateData({
      appBasic: {
        ...data.appBasic,
        icd104: selectedValue,
      },
    })
    setIcdData4([])
    setDropdownVisible4(false)
  }

  const fetchMemberDetail = async () => {
    const apiUrl = `${process.env.REACT_APP_API_USER_URL}/api/Data/Provider/GetMemberByCard?ProviderCode=${user.currentUser?.providerCode}&CardNo=${parsedMemberDetail?.CardNumber}&Dob=${parsedMemberDetail?.DateOfBirth}`
    const headers = {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${auth?.token}` || `Bearer ${user.currentUser?.token}`,
    }
    try {
      const response = await axios.get(apiUrl, {headers})
      if (response.data.isSuccess) {
        const productCodeData = response.data.data.productCode
        setProductCode(productCodeData)
        setIsProductCodeLoaded(true)
        console.log('Product code set:', productCodeData)
      }
    } catch (err) {
      console.error('Error fetching member detail:', err)
      setIsProductCodeLoaded(true) // Set to true even on error to prevent infinite loading
    }
  }

  useEffect(() => {
    fetchMemberDetail()
  }, [])

  useEffect(() => {
    console.log(data)
    const isValid = validateData()
    onValidationChange(isValid)
  }, [data, onValidationChange])

  const validateData = () => {
    return (
      !!data.appBasic.icd10 &&
      data.appBasic.icd10.trim() !== '' 
      // &&
      // !!data.appBasic.laboratorium &&
      // data.appBasic.laboratorium.trim() !== '' &&
      // !!data.appBasic.generalCondition &&
      // data.appBasic.generalCondition.trim() !== ''
    )
  }

  const handleKeyDown = (e: React.KeyboardEvent) => {
    if (e.key === 'Enter') {
      e.preventDefault()
    }
  }

  return (
    <div className='current' data-kt-stepper-element='content'>
      <div className='w-100'>
        {/* ICD-10 Input Field */}
        <div className='fv-row mb-10'>
          <label className='d-flex align-items-center fs-5 fw-semibold mb-2'>
            <span className='required'>ICD-10</span>
          </label>
          <div className='input-container' style={{position: 'relative'}}>
            <input
              type='text'
              className='form-control form-control-lg form-control-solid'
              placeholder='Search ICD-10...'
              value={data.appBasic.icd10 || ''}
              onChange={(e) => handleInputChange('icd10', e)}
              onFocus={() => setDropdownVisible(icdData.length > 0)}
              onKeyDown={handleKeyDown}
              style={getInputStyle('icd10')}
              onMouseEnter={() => setHoveredInput('icd10')}
              onMouseLeave={() => setHoveredInput('')}
            />
            {dropdownVisible && icdData.length > 0 && (
              <div
                style={{
                  position: 'absolute',
                  top: '100%',
                  left: 0,
                  width: '100%',
                  backgroundColor: 'white',
                  border: '1px solid #ccc',
                  boxShadow: '0 2px 5px rgba(0,0,0,0.2)',
                  zIndex: 9999,
                  maxHeight: '200px',
                  overflowY: 'auto',
                }}
              >
                {icdData.map((icd: any, index: number) => (
                  <div
                    key={index}
                    className='dropdown-item'
                    onClick={() => handleSelectIcd(icd)}
                    style={{padding: '8px 12px', cursor: 'pointer'}}
                    onMouseDown={(e) => e.preventDefault()}
                  >
                    {icd.code} - {icd.name}
                  </div>
                ))}
              </div>
            )}
          </div>
        </div>

        {/* Second ICD-10 Field */}
        <div className='fv-row mb-10'>
          <label className='d-flex align-items-center fs-5 fw-semibold mb-2'>
            <span className='optional'>ICD-10 (2)</span>
          </label>
          <div className='input-container' style={{position: 'relative'}}>
            <input
              type='text'
              className='form-control form-control-lg form-control-solid'
              placeholder='Search ICD-10 (2)...'
              value={data.appBasic.icd102 || ''}
              onChange={(e) => handleInputChange2('icd102', e)}
              onFocus={() => setDropdownVisible2(icdData2.length > 0)}
              onKeyDown={handleKeyDown}
              style={getInputStyle('icd102')}
              onMouseEnter={() => setHoveredInput('icd102')}
              onMouseLeave={() => setHoveredInput('')}
            />
            {dropdownVisible2 && icdData2.length > 0 && (
              <div
                style={{
                  position: 'absolute',
                  top: '100%',
                  left: 0,
                  width: '100%',
                  backgroundColor: 'white',
                  border: '1px solid #ccc',
                  boxShadow: '0 2px 5px rgba(0,0,0,0.2)',
                  zIndex: 9999,
                  maxHeight: '200px',
                  overflowY: 'auto',
                }}
              >
                {icdData2.map((icd: any, index: number) => (
                  <div
                    key={index}
                    className='dropdown-item'
                    onClick={() => handleSelectIcd2(icd)}
                    style={{padding: '8px 12px', cursor: 'pointer'}}
                    onMouseDown={(e) => e.preventDefault()}
                  >
                    {icd.code} - {icd.name}
                  </div>
                ))}
              </div>
            )}
          </div>
        </div>

        {/* ICD-10 (3) Field */}
        <div className='fv-row mb-10'>
          <label className='d-flex align-items-center fs-5 fw-semibold mb-2'>
            <span className='optional'>ICD-10 (3)</span>
          </label>
          <div className='input-container' style={{position: 'relative'}}>
            <input
              type='text'
              className='form-control form-control-lg form-control-solid'
              placeholder='Search ICD-10 (3)...'
              value={data.appBasic.icd103 || ''}
              onChange={(e) => handleInputChange3('icd103', e)}
              onFocus={() => setDropdownVisible3(icdData3.length > 0)}
              onKeyDown={handleKeyDown}
              style={getInputStyle('icd103')}
              onMouseEnter={() => setHoveredInput('icd103')}
              onMouseLeave={() => setHoveredInput('')}
            />
            {dropdownVisible3 && icdData3.length > 0 && (
              <div
                style={{
                  position: 'absolute',
                  top: '100%',
                  left: 0,
                  width: '100%',
                  backgroundColor: 'white',
                  border: '1px solid #ccc',
                  boxShadow: '0 2px 5px rgba(0,0,0,0.2)',
                  zIndex: 9999,
                  maxHeight: '200px',
                  overflowY: 'auto',
                }}
              >
                {icdData3.map((icd: any, index: number) => (
                  <div
                    key={index}
                    className='dropdown-item'
                    onClick={() => handleSelectIcd3(icd)}
                    style={{padding: '8px 12px', cursor: 'pointer'}}
                    onMouseDown={(e) => e.preventDefault()}
                  >
                    {icd.code} - {icd.name}
                  </div>
                ))}
              </div>
            )}
          </div>
        </div>

        {/* ICD-10 (4) Field */}
        <div className='fv-row mb-10'>
          <label className='d-flex align-items-center fs-5 fw-semibold mb-2'>
            <span className='optional'>ICD-10 (4)</span>
          </label>
          <div className='input-container' style={{position: 'relative'}}>
            <input
              type='text'
              className='form-control form-control-lg form-control-solid'
              placeholder='Search ICD-10 (4)...'
              value={data.appBasic.icd104 || ''}
              onChange={(e) => handleInputChange4('icd104', e)}
              onFocus={() => setDropdownVisible4(icdData4.length > 0)}
              onKeyDown={handleKeyDown}
              style={getInputStyle('icd104')}
              onMouseEnter={() => setHoveredInput('icd104')}
              onMouseLeave={() => setHoveredInput('')}
            />
            {dropdownVisible4 && icdData4.length > 0 && (
              <div
                style={{
                  position: 'absolute',
                  top: '100%',
                  left: 0,
                  width: '100%',
                  backgroundColor: 'white',
                  border: '1px solid #ccc',
                  boxShadow: '0 2px 5px rgba(0,0,0,0.2)',
                  zIndex: 9999,
                  maxHeight: '200px',
                  overflowY: 'auto',
                }}
              >
                {icdData4.map((icd: any, index: number) => (
                  <div
                    key={index}
                    className='dropdown-item'
                    onClick={() => handleSelectIcd4(icd)}
                    style={{padding: '8px 12px', cursor: 'pointer'}}
                    onMouseDown={(e) => e.preventDefault()}
                  >
                    {icd.code} - {icd.name}
                  </div>
                ))}
              </div>
            )}
          </div>
        </div>

        <label className='d-flex align-items-center fs-5 fw-semibold mb-2 mt-5'>
          <span className='optional'>Laboratorium</span>
        </label>
        <textarea
          className='form-control form-control-lg'
          name='laboratorium'
          placeholder=''
          value={data.appBasic.laboratorium}
          onKeyDown={handleKeyDown}
          onChange={(e) =>
            updateData({
              appBasic: {
                ...data.appBasic,
                laboratorium: e.target.value,
              },
            })
          }
          style={getInputStyle('laboratorium')}
          onMouseEnter={() => setHoveredInput('laboratorium')}
          onMouseLeave={() => setHoveredInput('')}
        />

        <label className='d-flex align-items-center fs-5 fw-semibold mb-2 mt-5'>
          <span className='optional'>General Condition</span>
        </label>
        <textarea
          className='form-control form-control-lg'
          name='generalCondition'
          placeholder=''
          value={data.appBasic.generalCondition}
          onChange={(e) =>
            updateData({
              appBasic: {
                ...data.appBasic,
                generalCondition: e.target.value,
              },
            })
          }
          style={getInputStyle('generalCondition')}
          onMouseEnter={() => setHoveredInput('generalCondition')}
          onMouseLeave={() => setHoveredInput('')}
        />
      </div>
    </div>
  )
}

export {Step1}
